export default {
  basePath: '/',
  title: 'Tio Boot Admin',
}
